// Fixed nav when scroll

var scrollFixNav = {
  init: function (root_class) {
    // var s = this;
    // if ($('.fix-title').length) scrollFixNav.fix_title();

    if (root_class == undefined) {
      root_class = document;
    }

    var sticky_holder = $(root_class).find('.sticky_holder');
    var sticky_el = $(root_class).find('.stickynav');
    var window_w = $(window).width();
    var offset_top = 0;

    if (sticky_el.length == 0) return;

    if (window_w < 768) offset_top = $('#headernav .headernav-wrap').innerHeight();

    var sticky = function () {
      offset_top = 0;

      var top = sticky_holder[0].getBoundingClientRect().top;
      // console.log(top);
      // var search_el = $('.asl_w_container');
      window_w = $(window).width();
      
      if (window_w < 768) offset_top = $('#headernav .headernav-wrap').innerHeight();
      
      if (top <= offset_top) {
        body_el.addClass('is_sticky_nav');
        sticky_el.addClass('is_sticky');

        // if (window_w < 960) {
        //   $('.filtermain-search').append(search_el);
        // } else {
        //   $('.filterbar-search').append(search_el);
        // }
          
      } else {
        body_el.removeClass('is_sticky_nav');
        sticky_el.removeClass('is_sticky');


        // $('.filterbar-search').append(search_el);
      }
    }

    var holder_resize = function () {
      var pt = parseInt(sticky_holder.css('padding-top'));
      var pb = parseInt(sticky_holder.css('padding-bottom'));
      var endh = parseInt(sticky_el.innerHeight()) + pt + pb;
    
      sticky_holder.css('height', endh);
      sticky();
    }

    holder_resize();
    $(root_class).off('scroll.sticky').on('scroll.sticky', sticky);
    $(window).off('resize.sticky').on('resize.sticky', holder_resize);
  },

  fix_title: function (root_el, scroll_wrap_el) {
    if (root_el == undefined) {
      root_el = $(document);
    }

    if (scroll_wrap_el == undefined) {
      scroll_wrap_el = $(document);
    }

    var title_el = root_el.find('.fixed-title');
    var scroll_el = $(title_el.data('scrollel'));
    var totop_btn = title_el.find('#modal_totopbtn');
    var offset_top = 0;

    totop_btn.click(function () {
      scroll_wrap_el.scrollTop(0);
      // $(root_class).scrollTo(0, 600);
    });

    var sticky = function () {
      // var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
      var top = scroll_el[0].getBoundingClientRect().top;
      // console.log(top);
      
      if (top <= offset_top) {
        // if (root_el.is('.ttmodal.news')) root_el.addClass('fix_title_in');
        title_el.addClass('showin');
      } else {
        // root_el.removeClass('fix_title_in');
        title_el.removeClass('showin');
      }
    }

    sticky();
    scroll_wrap_el.off('scroll.stickytitle').on('scroll.stickytitle', sticky);
    $(window).off('resize.stickytitle').on('resize.stickytitle', sticky);
  }
}